import { DEFAULT_INITIAL_SETTINGS } from './constants/initial-settings'
import { onAdd, onRemove } from './utils/class-list'

let classFocus = DEFAULT_INITIAL_SETTINGS.classNames.focus

export const onFocusInput = (nodesInputs = null) => {
  if (nodesInputs === null) return null

  let parent_element

  nodesInputs.forEach((input) => {
    input.addEventListener('focus', function (event) {
      if (input.previousElementSibling !== null && input.previousElementSibling.classList.contains('hidden')) return null
      event.preventDefault()

      parent_element = input.parentElement
      if (parent_element === null) return null
      onAdd(parent_element, classFocus)
    })

    input.addEventListener('blur', function (event) {
      if (input.classList.contains('datepicker')) return null

      if (input.previousElementSibling !== null && input.previousElementSibling.classList.contains('hidden')) return null

      if (input.value !== '') return null
      event.preventDefault()

      parent_element = input.parentElement
      if (parent_element === null) return null
      onRemove(parent_element, classFocus)
    })
  })
}

export function onAutoFitInput(nodesInputs = null) {
  if (nodesInputs === null) return null

  nodesInputs.forEach((input) => {
    input.setAttribute('autocomplete', 'off')
  })
}
